import {createContext} from "react";


export const DateFieldsContext = createContext()